<div class="year-editor" style="padding: 2em;">
	<form class="year-editor-form" [formGroup]="formG1" style="text-align: left;">
		<div class="inputRowScreenColPhone">
			<triv-input [fGroup]="formG1" [data]="myInputs.bjJahr"></triv-input>
			<triv-input [fGroup]="formG1" [data]="myInputs.bjAnpassungsfaktorVGV"></triv-input>
		</div>
		<div class="inputRowScreenColPhone">
			<triv-input [fGroup]="formG1" [data]="myInputs.bjVon"></triv-input>
			<triv-input [fGroup]="formG1" [data]="myInputs.bjBis"></triv-input>
		</div>
		<div *ngIf="dateError.length"
			style="color: red; font-size: larger; margin-bottom: 2em; text-align: center;">
			{{dateError}}
		</div>
		<div>
			<triv-input [fGroup]="formG1" [data]="myInputs.bjFreigabe"></triv-input>
			<span class="customBtn" (click)="showInfoFreigabe()">
				<span class="material-icons" 
					style="vertical-align: middle; margin-left: 1em">info_outline</span>
			</span>
		</div>
		<div>
			<triv-input [fGroup]="formG1" [data]="myInputs.bjSichtbar"></triv-input>
		</div>

		
		<div style="margin-top: 2em; display: flex; flex-flow: row; justify-content: flex-end">
			<button mat-raised-button 
				*ngIf="bCreation"
				(click)="cancel()">Abbrechen</button>
			<span style="width: 2em"></span>
			<button mat-raised-button 
				[disabled]="formG1.pristine"
				(click)="reset()">Zurücksetzen</button>
			<span style="width: 2em"></span>
			<button mat-raised-button color="primary" 
				(click)="save()" 
				[disabled]="!formG1.valid || formG1.pristine">
				Speichern
			</button>
		</div>

	</form>
</div>